import { render, staticRenderFns } from "./v-aside.vue?vue&type=template&id=ea94e15e&scoped=true&"
import script from "./v-aside.vue?vue&type=script&lang=js&"
export * from "./v-aside.vue?vue&type=script&lang=js&"
import style0 from "./v-aside.vue?vue&type=style&index=0&id=ea94e15e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea94e15e",
  null
  
)

export default component.exports